var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06501 0.242711L4.48528 3.82244L0.905553 0.242711C0.72249 0.0596476 0.425704 0.0596476 0.242641 0.242711C0.0595773 0.425774 0.0595773 0.72256 0.242641 0.905624L3.82237 4.48535L0.242641 8.06508C0.0595773 8.24814 0.0595773 8.54493 0.242641 8.72799C0.425704 8.91106 0.72249 8.91106 0.905553 8.72799L4.48528 5.14826L8.06501 8.72799C8.24807 8.91106 8.54486 8.91106 8.72792 8.72799C8.91099 8.54493 8.91098 8.24814 8.72792 8.06508L5.14819 4.48535L8.72792 0.905624C8.91098 0.722561 8.91099 0.425774 8.72792 0.242711C8.54486 0.0596476 8.24807 0.059648 8.06501 0.242711Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.11b6c9e9b7b404c564077f75dfbb4add.svg";
export { ForwardRef as ReactComponent };